// get products
export const getProducts = (products, category, type, limit, template) => {
  if (products.length == 0) return {};
  if (products.length == undefined) return {};

  const finalProducts = category
    ? template
      ? products.filter(
          (product) =>
            product.category === category && product.templates === template
        )
      : products.filter((product) => product.category === category)
    : products;

  if (type && type === "new") {
    const newProducts = finalProducts.filter((single) => single.new);
    return newProducts.slice(0, limit ? limit : newProducts.length);
  }
  if (type && type === "bestSeller") {
    return finalProducts
      .sort((a, b) => {
        return b.saleCount - a.saleCount;
      })
      .slice(0, limit ? limit : finalProducts.length);
  }
  if (type && type === "saleItems") {
    return finalProducts.filter(
      (single) => single.discount && single.discount > 0
    );
  }
  return finalProducts.slice(0, limit ? limit : finalProducts.length);
};

// get product discount price
export const getDiscountPrice = (price, discount, pricesco, product) => {
  var price = pricesco
    ? pricesco
    : discount && discount > 0
    ? price - price * (discount / 100)
    : null;
  if (global.aziendaID == 2 && product?.altdat2)
    price = pricesco * (1 + parseInt(product?.altdat2) / 100);
  return price;
};
// get product discount price
export const getFinalPriceVariation = (product, color, size) => {
  var price = 0;

  product.variation.map((single) => {
    if (single && single.color == color) {
      if (single.size != undefined) {
        single.size.map((s) => {
          if (s.name == size) {
            ////console.log(s.price)
            price = s.pricesco;
          }
        });
      }
    } else {
      console.log("Errore con articolo " + product);
    }
  });
  if (global.aziendaID == 2)
    price = product.pricesco * (1 + parseInt(product?.altdat2) / 100);
  if (global.aziendaID == 4) price = product.pricesco;

  return price ? price : product.price;
};
// get product cart quantity
export const getProductCartQty = (cartItems, product, color, size) => {
  if (!product || !product.id) return 0;
  let productInCart = cartItems?.filter(
    (single) =>
      single.id === product.id &&
      (single.selectedProductColor
        ? single.selectedProductColor.trim() === color
        : true) &&
      (single.selectedProductSize ? single.selectedProductSize === size : true)
  )[0];
  if (cartItems?.length >= 1 && productInCart) {
    if (product.variation.length > 0) {
      return cartItems.filter(
        (single) =>
          single.id === product.id &&
          single.selectedProductColor.trim() === color &&
          single.selectedProductSize === size
      )[0].quantity;
    } else {
      return cartItems?.filter((single) => product.id === single.id)[0]
        .quantity;
    }
  } else {
    return 0;
  }
};

export const getSortedProductsNew = (products, sortValues) => {
  if (products && sortValues && Object.keys(sortValues).length > 0) {
    var fields = Object.keys(sortValues);
    var filtered = products;
    fields.map((field) => {
      var prods = [];
      var values = sortValues[field].split("|");
      values.map((value) => {
        var filterProds = products;
        if (value != "all" && value != "") {
          filterProds = products.filter((product) => {
            let trovatoCorrispondenza = false;
            if (field === "size") {
              product.variation.forEach((single) => {
                if (single.size)
                  return single.size.forEach((single) => {
                    if (sortValues?.size?.split("|").includes(single.name))
                      trovatoCorrispondenza = true;
                    return;
                  });
              });
            } else if (field === "color") {
              product.variation.forEach((single) => {
                if (single) {
                  if (
                    sortValues?.color
                      ?.split("|")
                      .includes(single.color.split("-")[0])
                  )
                    trovatoCorrispondenza = true;
                  return;
                }
              });
            } else {
              trovatoCorrispondenza =
                product[field] === value || product[field].includes(value);
            }
            return trovatoCorrispondenza;
          });
        }
        /*if (field == "tag") {
          if (prods.length == 0) prods = filterProds
          var arrays = [prods, filterProds]
          prods = arrays.reduce((a, b) => a.filter(c => b.includes(c)));
        }
        else */ prods = prods.concat(filterProds);
      });
      filtered = filtered.filter((value) => prods.includes(value));
    });
    return filtered;
  }
  return products;
};
//get products based on category
export const getSortedProducts = (products, sortType, sortValue) => {
  if (products && sortType && sortValue) {
    if (sortType === "name, sku") {
      //console.log(products);
      //console.log(sortValue);
      return products.filter((product) =>
        product.name && product.sku
          ? product.name.toLowerCase().includes(sortValue.toLowerCase()) ||
            product.sku.toLowerCase().includes(sortValue.toLowerCase())
          : null
      );
    }
    if (sortType === "name, sku, codAlt") {
      return products.filter((product) =>
        product.name && product.sku && product.codiciAlternativi
          ? product.name.toLowerCase().includes(sortValue.toLowerCase()) ||
            product.sku.toLowerCase().includes(sortValue.toLowerCase()) ||
            product.codiciAlternativi?.some((cod) =>
              cod.CodAlt?.toLowerCase().includes(sortValue.toLowerCase())
            )
          : product.name && product.sku
          ? product.name.toLowerCase().includes(sortValue.toLowerCase()) ||
            product.sku.toLowerCase().includes(sortValue.toLowerCase())
          : null
      );
    }
    if (sortType === "category") {
      return products.filter((product) => product.category == sortValue);
    }
    if (sortType === "subcategory") {
      return products.filter((product) => product.subcategory == sortValue);
    }
    if (sortType === "brands") {
      return products.filter((product) => product.brands == sortValue);
    }
    if (sortType === "templates") {
      return products.filter((product) => product.templates == sortValue);
    }
    if (sortType === "seasons") {
      return products.filter((product) => product.seasons == sortValue);
    }
    if (sortType === "tag") {
      return products.filter(
        (product) => product.tag.filter((single) => single === sortValue)[0]
      );
    }
    if (sortType === "color") {
      return products.filter(
        (product) =>
          product.variation &&
          product.variation.filter((single) => single.color === sortValue)[0]
      );
    }
    if (sortType === "size") {
      return products.filter(
        (product) =>
          product.variation &&
          product.variation.filter(
            (single) =>
              single.size.filter((single) => single.name === sortValue)[0]
          )[0]
      );
    }
    if (sortType === "name") {
      return products.filter((single) =>
        single.name.toLowerCase().includes(sortValue.toLowerCase())
      );
    }
    if (sortType === "filterSort") {
      let sortProducts = [...products];
      if (sortValue === "default") {
        return sortProducts;
      }
      if (sortValue === "priceHighToLow") {
        return sortProducts.sort((a, b) => {
          return b.price - a.price;
        });
      }
      if (sortValue === "priceLowToHigh") {
        return sortProducts.sort((a, b) => {
          return a.price - b.price;
        });
      }
    }
  }
  return products;
};

// get unique element
const getUniqueElemArray = (array) => {
  let uniqueElemArray = array.filter(function (v, i, self) {
    return i === self.indexOf(v);
  });
  return uniqueElemArray;
};
export const getProductWithCategory = (products, category) => {
  return products.filter((product) => product.category == category).length;
};
export const getProductWithSubCategory = (products, category, subcategory) => {
  return products.filter(
    (product) =>
      product.category == category && product.subcategory == subcategory
  ).length;
};
export const getProductWithBrand = (products, category, subcategory, brand) => {
  return products.filter(
    (product) =>
      product.category == category &&
      product.subcategory == subcategory &&
      product.brands == brand
  ).length;
};
export const getProductWithTag = (products, tag) => {
  return products.filter((product) => product.tag.includes(tag)).length;
};
export const getProductWithCategoryAndTag = (products, tag, category) => {
  return products.filter(
    (product) => product.tag.includes(tag) && product.category == category
  ).length;
};
// get unique categories
export const getUniqueCategories = (products) => {
  let productCategories = [];
  if (products == undefined) return null;
  if (products == null) return null;
  if (products.length == 0) return null;
  if (products.length == undefined) return null;

  products.map((product) => {
    return productCategories.push(product.category);
    /*
    return (
      product.category &&
      product.category.map(single => {
        return productCategories.push(single);
      })
    );*/
  });
  const uniqueProductCategories = getUniqueElemArray(productCategories);
  return uniqueProductCategories;
};

// get unique categories
export const getUniqueSubCategories = (products) => {
  let productSubCategories = [];
  if (products == undefined) return null;
  if (products == null) return null;
  if (products.length == 0) return null;
  if (products.length == undefined) return null;

  products.map((product) => {
    return productSubCategories.push(product?.subcategory);
    /*      
    return (
      product.subcategory &&
      product.subcategory.map(single => {
        return productSubCategories.push(single);
      })
    );*/
  });
  const uniqueProductSubCategories = getUniqueElemArray(productSubCategories);
  return uniqueProductSubCategories;
};

// get unique brand
export const getUniqueBrands = (products) => {
  let productbrands = [];
  if (products == undefined) return null;
  if (products == null) return null;
  if (products.length == 0) return null;
  if (products.length == undefined) return null;

  products.map((product) => {
    return productbrands.push(product?.brands);
    /*

  return (
    product.brands &&
    product.brands.map(single => {
      return productbrands.push(single);
    })
  );*/
  });
  const uniqueProductbrands = getUniqueElemArray(productbrands);
  return uniqueProductbrands;
};
// get unique colours
export const getUniqueColours = (products) => {
  let productcolours = [];
  if (products == undefined) return null;
  if (products == null) return null;
  if (products.length == 0) return null;
  if (products.length == undefined) return null;

  products.map((product) => {
    var variations = product?.variation;
    variations.forEach((v) =>
      productcolours.push({ color: v?.color, hexColor: v?.hexColor })
    );
    //return productcolours.push(product?.brands);
    /*

  return (
    product.brands &&
    product.brands.map(single => {
      return productbrands.push(single);
    })
  );*/
  });
  const uniqueProductColors = getUniqueElemArray(productcolours);
  return uniqueProductColors;
};
// get unique template
export const getUniqueTemplates = (products) => {
  let productTemplates = [];
  if (products == undefined) return null;
  if (products == null) return null;
  if (products.length == 0) return null;
  if (products.length == undefined) return null;

  products.map((product) => {
    return productTemplates.push(product?.templates);
    /*
    return (
      product.templates &&
      product.templates.map(single => {
        return productTemplates.push(single);
      })
    );*/
  });
  const uniqueProductTemplates = getUniqueElemArray(productTemplates);
  return uniqueProductTemplates;
};

// get unique season
export const getUniqueSeasons = (products) => {
  let productSeasons = [];
  if (products == undefined) return null;
  if (products == null) return null;
  if (products.length == 0) return null;
  if (products.length == undefined) return null;

  products.map((product) => {
    return productSeasons.push(product?.seasons);
    /*
    return (
      product.seasons &&
      product.seasons.map(single => {
        return productSeasons.push(single);
      })
    );*/
  });
  const uniqueProductSeasons = getUniqueElemArray(productSeasons);
  return uniqueProductSeasons;
};

// get unique tags
export const getUniqueTags = (products) => {
  let productTags = [];
  if (products == undefined) return null;
  if (products == null) return null;
  if (products.length == 0) return null;
  if (products.length == undefined) return null;

  products.map((product) => {
    return (
      product.tag &&
      product.tag.map((single) => {
        return productTags.push(single);
      })
    );
  });
  const uniqueProductTags = getUniqueElemArray(productTags);
  return uniqueProductTags;
};

// get unique colors
/*export const getUniqueColors = (products) => {
  let productColors = [];
  if (products == undefined) return null;
  if (products == null) return null;
  if (products.length == 0) return null;
  if (products.length == undefined) return null;

  products.map((product) => {
    return (
      product.variation &&
      product.variation.map((single) => {
        var colorString = single.color
          .split(";")[0]
          .split("-")[1]
          .split(" (")[0];
        var hexColor = single.color.split(";")[1];
        var colorSigla = single.color.split(";")[0].split("-")[0];
        return productColors.push(
          colorSigla +
            "-" +
            colorString +
            " (" +
            colorSigla +
            ");" +
            single.hexColor
        );
      })
    );
  });
  const uniqueProductColors = getUniqueElemArray(productColors);
  return uniqueProductColors;
};*/
// Funzione per calcolare la luminanza di un colore esadecimale
const getLuminance = (hexColor) => {
  if (!hexColor || hexColor.length !== 7) return 0; // Se non c'è l'hex valido, restituisci una luminanza minima

  // Rimuovi il simbolo '#' se presente
  hexColor = hexColor.startsWith("#") ? hexColor.slice(1) : hexColor;

  // Converti il colore esadecimale in componenti R, G, B
  const r = parseInt(hexColor.slice(0, 2), 16) / 255;
  const g = parseInt(hexColor.slice(2, 4), 16) / 255;
  const b = parseInt(hexColor.slice(4, 6), 16) / 255;

  // Calcola la luminanza percepita (standard ITU-R BT.709)
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

  return luminance;
};
const hexToHSL = (hex) => {
  // Rimuovi il simbolo "#" se presente
  hex = hex.replace(/^#/, "");

  // Estrai i componenti RGB
  const r = parseInt(hex.slice(0, 2), 16) / 255;
  const g = parseInt(hex.slice(2, 4), 16) / 255;
  const b = parseInt(hex.slice(4, 6), 16) / 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const delta = max - min;

  let h = 0;
  let s = 0;
  let l = (max + min) / 2;

  if (delta !== 0) {
    s = delta / (1 - Math.abs(2 * l - 1));
    switch (max) {
      case r:
        h = (g - b) / delta + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / delta + 2;
        break;
      case b:
        h = (r - g) / delta + 4;
        break;
    }
    h /= 6;
  }

  // Restituisci l'oggetto HSL con la luminosità (L)
  return {
    h: h * 360, // Tonalità (Hue)
    s: s * 100, // Saturazione (Saturation)
    l: l * 100, // Luminosità (Lightness)
  };
};

const getLightness = (hexColor) => {
  const { l } = hexToHSL(hexColor);
  return l;
};

const getHue = (hexColor) => {
  const { h } = hexToHSL(hexColor);
  return h;
};
function toColor(i) {
  if (!i) return undefined;
  /*var hex = (i & 0xFF).toString(16) +
          ((i >> 8) & 0xFF).toString(16) +
          ((i >> 16) & 0xFF).toString(16) +
          ((i >> 24) & 0xFF).toString(16);

  hex = hex.substring(0, 6);
  
  return "#" + hex;*/
  var r = Math.floor(i / 65536);
  var g = Math.floor((i - r * 65536) / 256);
  var b = Math.floor(i - r * 65536 - g * 256);
  var rHex = Number(r).toString(16);
  var gHex = Number(g).toString(16);
  var bHex = Number(b).toString(16);
  rHex = rHex.length < 2 ? "0" + rHex : rHex;
  gHex = gHex.length < 2 ? "0" + gHex : gHex;
  bHex = bHex.length < 2 ? "0" + bHex : bHex;
  return "#" + bHex + gHex + rHex;
}
export const getUniqueColors = (products) => {
  if (!products || !Array.isArray(products) || products.length === 0)
    return null;

  let productColors = [];
  let addedColorSiglas = new Set(); // Per tenere traccia delle colorSigla già aggiunte

  products.forEach((product) => {
    if (product.variation) {
      product.variation.forEach((single) => {
        const colorString = single.color
          .split(";")[0]
          .split("-")[1]
          .split(" (")[0];
        const hexColor = single.hexColor;
        const colorSigla = single.color.split(";")[0].split("-")[0];

        // Aggiungi solo se la colorSigla non è già stata inserita
        if (!addedColorSiglas.has(colorSigla)) {
          productColors.push(
            {
              colorSigla,
              colorString,
              hexColor: toColor(hexColor),
              fullString:
                colorSigla +
                "-" +
                colorString +
                " (" +
                colorSigla +
                ");" +
                hexColor,
            }
            //colorSigla + "-" + colorString + " (" + colorSigla + ");" + hexColor
          );
          addedColorSiglas.add(colorSigla); // Segna la colorSigla come aggiunta
        }
      });
    }
  });

  // Dividi i colori in due gruppi: quelli con hexColor e quelli senza
  const withHexColor = productColors.filter((color) => color.hexColor);
  const withoutHexColor = productColors.filter((color) => !color.hexColor);

  // Ordina i colori con hexColor per luminanza dal bianco al nero
  withHexColor.sort((a, b) => {
    const hueA = getHue(a.hexColor);
    const hueB = getHue(b.hexColor);
    return hueA - hueB; // Ordinamento in base alla tonalità
  });

  // Ordina i colori senza hexColor alfabeticamente
  withoutHexColor.sort((a, b) => a.colorString.localeCompare(b.colorString));

  // Unisci i due gruppi: prima i colori con hexColor, poi quelli senza
  const sortedColors = [...withHexColor, ...withoutHexColor];

  // Restituisci solo le stringhe complete
  return sortedColors.map((item) => item.fullString);
};

// get unique sizes
export const getProductsUniqueSizes = (products) => {
  let productSizes = [];
  if (products == undefined) return null;
  if (products == null) return null;
  if (products.length == 0) return null;
  if (products.length == undefined) return null;

  products.map((product) => {
    return (
      product.variation &&
      product.variation.map((single) => {
        if (single.size)
          return single.size.map((single) => {
            return productSizes.push(single.name);
          });
      })
    );
  });
  const uniqueProductSizes = getUniqueElemArray(productSizes);
  return uniqueProductSizes;
};

// get product unique sizes
export const getUniqueSizes = (product) => {
  let productSizes = [];
  if (product == undefined) return null;
  if (product == null) return null;
  if (product.length == 0) return null;
  if (product.length == undefined) return null;

  product.variation.map((singleVariation) => {
    return (
      singleVariation.size &&
      singleVariation.size.map((singleSize) => {
        return productSizes.push(singleSize.name);
      })
    );
  });
  const uniqueProductSizes = getUniqueElemArray(productSizes);
  return uniqueProductSizes;
};

export const setActiveSort = (e) => {
  const filterButtons = document.querySelectorAll(
    ".sidebar-widget-list-left button, .sidebar-widget-tag button, .product-filter button"
  );
  /*filterButtons.forEach(elem => {
    if(elem.classList.contains("active"))   elem.classList.remove("active");
  });*/
  e.currentTarget.classList.contains("active")
    ? e.currentTarget.classList.remove("active")
    : e.currentTarget.classList.add("active");
};

export const setActiveLayout = (e) => {
  const gridSwitchBtn = document.querySelectorAll(".shop-tab button");
  gridSwitchBtn.forEach((elem) => {
    elem.classList.remove("active");
  });
  e.currentTarget.classList.add("active");
};

export const toggleShopTopFilter = (e) => {
  const shopTopFilterWrapper = document.querySelector(
    "#product-filter-wrapper"
  );
  shopTopFilterWrapper.classList.toggle("active");
  if (shopTopFilterWrapper.style.height) {
    shopTopFilterWrapper.style.height = null;
  } else {
    shopTopFilterWrapper.style.height =
      shopTopFilterWrapper.scrollHeight + "px";
  }
  e.currentTarget.classList.toggle("active");
};
